import { html as o, when as t } from "@microsoft/fast-element";
const r = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 2.25C3.48122 2.25 2.25 3.48122 2.25 5C2.25 6.51878 3.48122 7.75 5 7.75C5.48685 7.75 5.94415 7.62349 6.34082 7.40154L8.87127 9.93199C8.47865 10.5248 8.25 11.2357 8.25 12C8.25 12.4503 8.32937 12.8821 8.47489 13.2821L6.65335 14.8023C6.19317 14.4556 5.62059 14.25 5 14.25C3.48122 14.25 2.25 15.4812 2.25 17C2.25 18.5188 3.48122 19.75 5 19.75C6.51878 19.75 7.75 18.5188 7.75 17C7.75 16.6464 7.68328 16.3085 7.56173 15.998L9.27071 14.5717C9.95452 15.2971 10.9244 15.75 12 15.75C12.7643 15.75 13.4752 15.5214 14.068 15.1287L16.5985 17.6592C16.3765 18.0558 16.25 18.5131 16.25 19C16.25 20.5188 17.4812 21.75 19 21.75C20.5188 21.75 21.75 20.5188 21.75 19C21.75 17.4812 20.5188 16.25 19 16.25C18.5131 16.25 18.0558 16.3765 17.6591 16.5985L15.1287 14.0681C15.5213 13.4752 15.75 12.7643 15.75 12C15.75 11.34 15.5795 10.7198 15.2801 10.1811L16.4416 9.26613C16.8846 9.57132 17.4214 9.75 18 9.75C19.5188 9.75 20.75 8.51878 20.75 7C20.75 5.48122 19.5188 4.25 18 4.25C16.4812 4.25 15.25 5.48122 15.25 7C15.25 7.39544 15.3335 7.77139 15.4837 8.11119L14.3037 9.0408C13.668 8.54523 12.8685 8.25 12 8.25C11.2357 8.25 10.5248 8.47867 9.93192 8.87132L7.4015 6.3409C7.62347 5.94421 7.75 5.48688 7.75 5C7.75 3.48122 6.51878 2.25 5 2.25Z"
      fill="currentColor"
    />
  </svg>
`, e = o`
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 7C20 8.10457 19.1046 9 18 9C16.8954 9 16 8.10457 16 7C16 5.89543 16.8954 5 18 5C19.1046 5 20 5.89543 20 7Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 5C7 6.10457 6.10457 7 5 7C3.89543 7 3 6.10457 3 5C3 3.89543 3.89543 3 5 3C6.10457 3 7 3.89543 7 5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 17C7 18.1046 6.10457 19 5 19C3.89543 19 3 18.1046 3 17C3 15.8954 3.89543 15 5 15C6.10457 15 7 15.8954 7 17Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 19C21 20.1046 20.1046 21 19 21C17.8954 21 17 20.1046 17 19C17 17.8954 17.8954 17 19 17C20.1046 17 21 17.8954 21 19Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M6 6L10 10" stroke="currentColor" stroke-width="1.5" />
    <path d="M14 14L18 18" stroke="currentColor" stroke-width="1.5" />
    <path
      d="M13.8614 10.344L16.6386 8.15615"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M7 15.49L9.7144 13.2246"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
`, n = o`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.16667 1.75C2.83198 1.75 1.75 2.83198 1.75 4.16667C1.75 5.50135 2.83198 6.58333 4.16667 6.58333C4.56062 6.58333 4.93255 6.48907 5.26115 6.32187L7.23325 8.29397C6.92683 8.78985 6.75 9.37427 6.75 10C6.75 10.3592 6.80829 10.7049 6.91592 11.0279L5.53895 12.1771C5.14916 11.9078 4.67634 11.75 4.16667 11.75C2.83198 11.75 1.75 12.832 1.75 14.1667C1.75 15.5014 2.83198 16.5833 4.16667 16.5833C5.50135 16.5833 6.58333 15.5014 6.58333 14.1667C6.58333 13.8879 6.53615 13.6202 6.44933 13.3711L7.71702 12.3131C8.30393 12.8924 9.1102 13.25 10 13.25C10.6258 13.25 11.2102 13.0731 11.7061 12.7667L13.6782 14.7388C13.511 15.0674 13.4167 15.4394 13.4167 15.8334C13.4167 17.1681 14.4986 18.2501 15.8333 18.2501C17.168 18.2501 18.25 17.1681 18.25 15.8334C18.25 14.4987 17.168 13.4167 15.8333 13.4167C15.4394 13.4167 15.0675 13.511 14.7389 13.6782L12.7668 11.706C13.0732 11.2101 13.25 10.6257 13.25 10C13.25 9.46599 13.1212 8.96205 12.893 8.51757L13.7076 7.87584C14.0814 8.11285 14.5247 8.25008 15 8.25008C16.3347 8.25008 17.4167 7.1681 17.4167 5.83341C17.4167 4.49873 16.3347 3.41675 15 3.41675C13.6653 3.41675 12.5833 4.49873 12.5833 5.83341C12.5833 6.14634 12.6428 6.44538 12.7511 6.71983L11.918 7.37607C11.3804 6.98242 10.7174 6.75 10 6.75C9.37424 6.75 8.78979 6.92685 8.2939 7.2333L6.32183 5.26123C6.48905 4.93261 6.58333 4.56065 6.58333 4.16667C6.58333 2.83198 5.50135 1.75 4.16667 1.75Z"
      fill="currentColor"
    />
  </svg>
`, s = o`
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.33333 1.3999C2.26558 1.3999 1.39999 2.26548 1.39999 3.33324C1.39999 4.40099 2.26558 5.26657 3.33333 5.26657C3.64849 5.26657 3.94604 5.19116 4.20891 5.0574L5.78659 6.63508C5.54146 7.03178 5.39999 7.49932 5.39999 7.9999C5.39999 8.2873 5.44662 8.5638 5.53273 8.82226L4.43115 9.74162C4.11932 9.52612 3.74106 9.3999 3.33333 9.3999C2.26558 9.3999 1.39999 10.2655 1.39999 11.3332C1.39999 12.401 2.26558 13.2666 3.33333 13.2666C4.40108 13.2666 5.26666 12.401 5.26666 11.3332C5.26666 11.1103 5.22891 10.8961 5.15946 10.6968L6.17361 9.8504C6.64313 10.3138 7.28816 10.5999 7.99999 10.5999C8.50061 10.5999 8.96819 10.4584 9.36491 10.2132L10.9426 11.7909C10.8088 12.0538 10.7333 12.3514 10.7333 12.6666C10.7333 13.7344 11.5989 14.6 12.6667 14.6C13.7344 14.6 14.6 13.7344 14.6 12.6666C14.6 11.5989 13.7344 10.7333 12.6667 10.7333C12.3515 10.7333 12.054 10.8087 11.7912 10.9424L10.2134 9.36469C10.4585 8.968 10.6 8.50047 10.6 7.9999C10.6 7.57269 10.497 7.16954 10.3144 6.81396L10.9661 6.30057C11.2651 6.49018 11.6197 6.59997 12 6.59997C13.0678 6.59997 13.9333 5.73438 13.9333 4.66663C13.9333 3.59888 13.0678 2.7333 12 2.7333C10.9323 2.7333 10.0667 3.59888 10.0667 4.66663C10.0667 4.91697 10.1142 5.1562 10.2009 5.37577L9.53443 5.90075C9.10435 5.58584 8.57389 5.3999 7.99999 5.3999C7.49939 5.3999 7.03183 5.54138 6.63511 5.78654L5.05745 4.20888C5.19124 3.94599 5.26666 3.64842 5.26666 3.33324C5.26666 2.26548 4.40108 1.3999 3.33333 1.3999Z"
      fill="currentColor"
    />
  </svg>
`, i = o`
  ${t((C) => C._type === "outline", e)}
  ${t((C) => C._type === "solid", r)}
  ${t((C) => C._type === "mini", n)}
  ${t((C) => C._type === "micro", s)}
`;
export {
  i as actionHubTemplate
};
